import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

export default function CheckEmailPage() {
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const handleResend = async () => {
    if (!email) return;
    setResending(true);
    try {
      const res = await fetch('/api/auth/resend-verification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.success) {
        setResent(true);
        toast.success('Verification email sent!');
        setTimeout(() => setResent(false), 30000);
      } else {
        toast.error(data.error || 'Failed to resend');
      }
    } catch {
      toast.error('Failed to resend verification email');
    } finally {
      setResending(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #FAF8F4 0%, #F0EDE6 100%)', padding: 20,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '48px 40px', maxWidth: 480, width: '100%',
        boxShadow: '0 8px 32px rgba(60,54,50,0.1)', textAlign: 'center',
      }}>
        {/* Gold accent bar */}
        <div style={{ height: 3, background: 'linear-gradient(90deg, #B8943A, #CCA94E, #B8943A)', borderRadius: '16px 16px 0 0', margin: '-48px -40px 32px', }} />

        <div style={{
          width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg, #FFF8E7, #FFF3D6)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px', fontSize: 28, boxShadow: '0 4px 12px rgba(184,148,58,0.15)',
        }}>
          ✉️
        </div>
        <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 26, fontWeight: 700, color: '#2E2A26', marginBottom: 8 }}>
          Check Your Email
        </h1>
        <p style={{ fontFamily: "'Sora', system-ui, sans-serif", fontSize: 14, color: '#8B8178', lineHeight: 1.7, marginBottom: 8 }}>
          {isRTL ? 'لقد أرسلنا رابط التحقق إلى:' : "We've sent a verification link to:"}
        </p>
        {email && (
          <p style={{
            fontFamily: "'Sora', system-ui, sans-serif", fontSize: 15, fontWeight: 600, color: '#B8943A', marginBottom: 24,
            padding: '10px 20px', background: '#FFF8E7', borderRadius: 10, display: 'inline-block',
            border: '1px solid rgba(184,148,58,0.2)',
          }}>
            {email}
          </p>
        )}
        <p style={{ fontFamily: "'Sora', system-ui, sans-serif", fontSize: 13, color: '#8B8178', lineHeight: 1.7, marginBottom: 28 }}>
          {isRTL ? 'انقر على الرابط في البريد الإلكتروني لتفعيل حسابك. إذا لم تجده، تحقق من مجلد الرسائل غير المرغوب فيها.' : "Click the link in the email to activate your account. If you don't see it, check your spam folder."}
        </p>

        <button
          onClick={handleResend}
          disabled={resending || resent}
          style={{
            width: '100%', padding: '14px 0', borderRadius: 10,
            background: resent ? '#7A8C52' : resending ? '#D5D0C8' : 'linear-gradient(135deg, #B8943A, #CCA94E)',
            color: resent ? '#fff' : resending ? '#8B8178' : '#2E2A26',
            fontFamily: "'Sora', system-ui, sans-serif", fontWeight: 700, fontSize: 14,
            border: 'none', cursor: resent ? 'default' : resending ? 'default' : 'pointer',
            marginBottom: 20, boxShadow: resent || resending ? 'none' : '0 4px 12px rgba(184,148,58,0.3)',
            transition: 'all 0.2s ease',
          }}
        >
          {resent ? (isRTL ? '✓ تم الإرسال!' : '✓ Email Sent!') : resending ? (isRTL ? 'جاري الإرسال...' : 'Sending...') : (isRTL ? 'إعادة إرسال بريد التحقق' : 'Resend Verification Email')}
        </button>

        <Link to="/login" style={{
          fontFamily: "'Sora', system-ui, sans-serif", display: 'block', fontSize: 13,
          color: '#B8943A', textDecoration: 'none', fontWeight: 600,
        }}>
          {isRTL ? 'العودة لتسجيل الدخول ←' : '← Back to Login'}
        </Link>
      </div>
    </div>
  );
}
